import { faSearch } from "@fortawesome/pro-regular-svg-icons";

import { ChatEmptyStatePrompt } from "src/base-components/Chat/types";
import { Icon } from "src/design-system/Icon";

type ChatEmptyStateSuggestionProps = {
  prompt: string;
  onClick: (prompt: string) => void;
};

const ChatEmptyStateSuggestion: React.FC<ChatEmptyStateSuggestionProps> = ({
  prompt,
  onClick,
}) => (
  <button
    className="flex h-32 w-36 appearance-none flex-col items-start gap-y-2 rounded-lg border border-gray-200 bg-gray-50 p-3 text-left font-inter-normal-12px"
    onClick={() => onClick(prompt)}
  >
    <Icon icon={faSearch} size="xs" />
    <p className="text-gray-800">{prompt}</p>
  </button>
);

type ChatEmptyStateProps = {
  prompts: ChatEmptyStatePrompt[];
  onPromptClick: (prompt: string) => void;
  dataLoc?: string;
};

export const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({
  prompts,
  onPromptClick,
  dataLoc,
}) => (
  <div
    className="flex h-full flex-grow flex-col items-center justify-center gap-x-2 gap-y-3 p-2"
    data-loc={dataLoc}
  >
    <p className="font-inter-normal-12px text-gray-500">Some ideas...</p>
    <div className="flex items-center gap-x-2">
      {prompts.map((item, index) => (
        <ChatEmptyStateSuggestion
          key={item.prompt + index}
          prompt={item.label}
          onClick={() => onPromptClick(item.prompt)}
        />
      ))}
    </div>
  </div>
);
